import { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'

interface IImageBackgroundProps {
  tabletHeight?: string /* pass unit, like 80vh or 1000px */
  desktopHeight?: string /* pass unit, like 80vh or 1000px */
  height?: string /* pass unit, like 80vh or 1000px */
  imgSrc: string
}
const ImageBackground = styled.div<IImageBackgroundProps>`
  height: ${props => props.height || '400px'};
  background: center / cover no-repeat url(${props => props.imgSrc});
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    height: ${props => props.tabletHeight || '500px'};
  }

  @media (min-width: ${props => props.theme.metrics.desktopLarge}px) {
    height: ${props => props.desktopHeight || '600px'};
  }
`

interface IOverlayProps {
  padding?: number
  defaultMargin?: number
  desktopPadding?: number
  tabletMargin?: number
  desktopMargin?: number
  borderRadius?: number
  desktopBorderRadius?: number
}
const Overlay = styled.div<IOverlayProps>`
  background: rgba(255, 255, 255, 0.9);
  margin: ${props => props.defaultMargin || '0'};
  padding: ${props => (props.padding ? `${props.padding}px` : '20px')};
  ${props => props.borderRadius && `border-radius: ${props.borderRadius}px;`}

  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    ${props => props.desktopPadding && `padding: ${props.desktopPadding}px`};
    ${props => props.tabletMargin && `margin: 0 ${props.tabletMargin}px`};
  }
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    ${props => props.desktopMargin && `margin: 0 ${props.desktopMargin}px`};
    ${props => props.desktopBorderRadius && `border-radius: ${props.desktopBorderRadius}px`};
  }
`

interface IProps {
  children: ReactNode
  height?: string
  tabletHeight?: string
  desktopHeight?: string
  imgSrc: string
  overlayPadding?: number
  desktopOverlayPadding?: number
  defaultMargin?: number
  tabletMargin?: number
  desktopMargin?: number
  borderRadius?: number
  desktopBorderRadius?: number
  ariaLabel?: string
}

const HeroWithContentOverlay: FunctionComponent<IProps> = ({
  children,
  height,
  tabletHeight,
  desktopHeight,
  imgSrc,
  overlayPadding,
  desktopOverlayPadding,
  defaultMargin,
  tabletMargin,
  desktopMargin,
  borderRadius,
  desktopBorderRadius,
  ariaLabel,
}) => (
  <ImageBackground
    height={height}
    tabletHeight={tabletHeight}
    desktopHeight={desktopHeight}
    imgSrc={imgSrc}
    aria-label={ariaLabel}
  >
    <Overlay
      padding={overlayPadding}
      desktopPadding={desktopOverlayPadding}
      defaultMargin={defaultMargin}
      tabletMargin={tabletMargin}
      desktopMargin={desktopMargin}
      borderRadius={borderRadius}
      desktopBorderRadius={desktopBorderRadius}
    >
      {children}
    </Overlay>
  </ImageBackground>
)

export default HeroWithContentOverlay
